import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import SocialLinks from './SocialLinks';
import useBrandingStore from '../store/brandingStore';
import useAuthStore from '../store/authStore';
import useTenantStore from '../store/tenantStore';

export default function PlatformFooter() {
  const { t } = useTranslation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isFeatureEnabled = useTenantStore((state) => state.isFeatureEnabled);
  const { siteName, socialLinks, load } = useBrandingStore();
  useEffect(() => { load(); }, [load]);

  return (
    <footer className="border-t border-surface-200 bg-white py-9">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-5 px-6 md:flex-row">
        <Link to="/"><Logo size={28} textColor="text-gray-900" wordmarkClassName="text-sm" /></Link>
        <SocialLinks links={socialLinks} className="justify-center" />
        <div className="flex flex-col items-center gap-2 text-sm text-gray-500 sm:flex-row sm:gap-5">
          <Link to="/store" className="hover:text-primary-600">{t('Store')}</Link>
          {isFeatureEnabled('teacher_profiles') && <Link to="/teachers" className="hover:text-primary-600">{t('Choose your teacher')}</Link>}
          {isFeatureEnabled('contact_messages') && <Link to="/contact" className="hover:text-primary-600">{t('Contact us')}</Link>}
          <Link to={isAuthenticated ? '/dashboard' : '/login'} className="hover:text-primary-600">{isAuthenticated ? t('Dashboard') : t('Login')}</Link>
        </div>
        <p className="text-xs text-gray-400">&copy; {new Date().getFullYear()} {siteName || "L'mcid"}</p>
      </div>
    </footer>
  );
}
